// Copyright TraderEvolution Global LTD. © 2017-2026. All rights reserved.
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import ModifyPositionFooterTemplate from '@front/templates/ModifyPositionFooterTemplate.html';
import ModifyPositionScreenTemplate from '@front/templates/ModifyPositionScreenTemplate.html';
import OrderEditControlsTemplate from '@front/templates/OrderEditControlsTemplate.html';
import { PositionEdit } from '@shared/commons/cache/OrderParams/PositionEdit';
import { DataCache } from '@shared/commons/DataCache';
import { CustomErrorClass, ErrorInformationStorage } from '@shared/commons/ErrorInformationStorage';
import { IsAllowed } from '@shared/commons/IsAllowed';
import { ResourcesManager } from '@shared/commons/properties/ResourcesManager';
import { TradingNumericErrorChecker } from '@shared/commons/Trading/TradingNumericErrorChecker';
import { Quantity } from '@shared/commons/UtilsClasses/Quantity';
import { Resources } from '@shared/localizations/Resources';
import { Control } from '../elements/Control';
import { OrderEditViewBase } from '../panels/OrderEditViewBase';
import { ScreensNames } from '../UtilsClasses/FactoryConstants';
// TODO. Refactor. Duplicate code of ModifyOrderScreen.
export class ModifyPositionScreen extends OrderEditViewBase {
    constructor() {
        super();
        this.Name = 'ModifyPositionScreen';
    }
    getType() {
        return ScreensNames.ModifyPositionScreen;
    }
    oninit() {
        super.oninit();
        void this.set('isRelativeStyle', true);
        void this.set('isAllowPadding', false);
        this.observe('position', this.onPosition);
        this.observe('tradingAllowed', this.onTradingAllowed);
        // TODO. Refactor.
        // TickAsync/Localize doesn't work for panels added with addScreen method.
        ResourcesManager.onLocaleChange.Subscribe(this.localize, this);
        Control.Ticker.Subscribe(this.TickAsync, this);
    }
    // TODO. Refactor.
    oncomplete() {
        super.oncomplete();
        const position = this.get('position');
        const isPositionModifyingAllowed = IsAllowed.IsPositionModifyingAllowed(position).Allowed;
        this.set('forbiddenPanel', !isPositionModifyingAllowed);
        this.activateNumeric(this.get('activateNumericLinkName'));
        this.onTradingAllowed(this.get('tradingAllowed'));
        this.addScrollToContainer('.modify-position-screen-body');
        this.localize();
    }
    onteardown() {
        ResourcesManager.onLocaleChange.UnSubscribe(this.localize, this);
        Control.Ticker.UnSubscribe(this.TickAsync, this);
        super.onteardown();
    }
    localize() {
        this.updatePanelHeader();
        void this.set({
            modifyBtnText: Resources.getResource('screen.modifyOrder.modify'),
            cancelBtnText: Resources.getResource('general.messageBox.cancel')
        });
    }
    onPosition(position) {
        if (isNullOrUndefined(position))
            return;
        this.set('instrument', position.Instrument);
        this.setOrderEdit(new PositionEdit({
            dataCache: DataCache,
            position,
            quantity: new Quantity(position.Amount, true)
        }));
        this.updatePanelHeader();
    }
    onTradingAllowed(allowed) {
        const modifyBtn = this.Controls.modifyBtn;
        if (!isNullOrUndefined(modifyBtn)) {
            modifyBtn.set('enabled', allowed);
        }
    }
    updatePanelHeader() {
        const position = this.get('position');
        if (isNullOrUndefined(position))
            return;
        void this.set('header', Resources.getResource('screen.modifyOrder.modifyPosition'));
    }
    layout() {
        // tODO. Refactor.
        this.updateOrderEditParametersVisibility();
        this.fire('onFillByPosition');
    }
    modify() {
        if (TradingNumericErrorChecker.HasErrors(this)) {
            return;
        }
        const oEd = this.orderEdit;
        oEd.placedFrom = this.get('placedFrom');
        oEd.UseSkipNoChange = true;
        const ordExec = DataCache.FOrderExecutor;
        let handler = () => __awaiter(this, void 0, void 0, function* () { return yield ordExec.modifyPositionPromise(oEd); });
        if (oEd instanceof PositionEdit && (oEd.IsProductTypeModified() || oEd.IsQuantityModified())) {
            handler = () => __awaiter(this, void 0, void 0, function* () { return yield ordExec.modifyPositionProductType(oEd); });
        }
        handler()
            .then((confirmed) => {
            if (confirmed) {
                this.closeScreen();
            }
        })
            .catch((err) => {
            if (err === 'cancell clicked') {
                return;
            }
            const ex = new CustomErrorClass('ModifyPositionScreen error', 'ModifyPositionScreen.modify', 'modify -> modifyPositionPromise');
            ErrorInformationStorage.GetException(ex);
        });
    }
    closeScreen() {
        const parentContainerControl = this.get('parentContainerControl');
        if (!isNullOrUndefined(parentContainerControl)) {
            parentContainerControl.close();
        }
    }
}
OrderEditViewBase.extendWith(ModifyPositionScreen, {
    data: function () {
        return {
            resizable: false,
            dockablePanel: false,
            showHeader: false,
            showFooter: true,
            showBorder: false,
            style_addition_body: 'modify-position-screen-body',
            position: null,
            quantity: null,
            SLNumericLink: null,
            TPNumericLink: null,
            MQNumericLink: null,
            activateNumericLinkName: null,
            attached: true
        };
    },
    partials: {
        // TODO. Refactor.
        bodyPartial: ModifyPositionScreenTemplate,
        orderEditControls: OrderEditControlsTemplate,
        footerPartial: ModifyPositionFooterTemplate
    }
});
